import { Injectable } from '@angular/core';
import { NgModel } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import swal from 'sweetalert';

@Injectable()
export class CustomMessageService {

  constructor(
    private _infoModal : NgbModal

  ) { }

  info(message: string, title?: string, isHtml?: boolean){
      
  }
  
  success(message: string, title?: string, isHtml?: boolean){

  }
  
  warn(message: string, title?: string, isHtml?: boolean){

  }
  
  error(message: string, title?: string, isHtml?: boolean){

	  swal(title ? title : '', message, 'error');

  }
  
  confirm(message: string, callback?: (result: boolean) => void) {

  }
  
 /*  confirm(message: string, title?: string, callback?: (result: boolean) => void, isHtml?: boolean){
    
  } */

}
